import { render, staticRenderFns } from "./TeamMember.vue?vue&type=template&id=ae1e243c&scoped=true"
import script from "./TeamMember.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMember.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TeamMember.vue?vue&type=style&index=0&id=ae1e243c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1e243c",
  null
  
)

export default component.exports